import {
  //GESTOR_ESTADO_ACEPTADA,
  GESTOR_ESTADO_LIQUIDACION_RESUELTA,
  //GESTOR_ESTADO_OBSERVADA,
  GESTOR_ESTADO_PENDIENTE_REVISION,
  GESTOR_ESTADO_PRE_LIQUIDACION,
} from "./gestor-centralizado.constants";

export function hasDirtyRows(items = []) {
  return items.some(
    (row) =>
      row._dirty ||
      (row.detalles && row.detalles.some((detalle) => detalle._dirty)),
  );
}

export function canSaveGestorCentralizado(estadoLiquidacion) {
  return estadoLiquidacion === GESTOR_ESTADO_PRE_LIQUIDACION;
}

export function canObserveGestorCentralizado(estadoLiquidacion, items = [], resumen = {}) {
  if (estadoLiquidacion !== GESTOR_ESTADO_PRE_LIQUIDACION) return false;
  if (hasDirtyRows(items)) return false;
  if (!resumen.existenObservadas) return false;
  return !resumen.existenPendientesSinResolver;
}
export function canEditCantidadGestor(estadoLiquidacion) {
  return (
    estadoLiquidacion === GESTOR_ESTADO_PRE_LIQUIDACION ||
    estadoLiquidacion === "LIQUIDACION_RESUELTA"
  );
}
export function canGenerateGestorCentralizado(estadoLiquidacion, items = [], resumen) {
  const estadosValidos = [
    GESTOR_ESTADO_PRE_LIQUIDACION,
    GESTOR_ESTADO_LIQUIDACION_RESUELTA,
  ];

  if (!estadosValidos.includes(estadoLiquidacion)) return false;
  if (hasDirtyRows(items)) return false;
  if (resumen?.existenPendientes) return false;
  if (resumen?.existenObservadas) return false;
  return true;
}

export function canEditPenalidadesGestor(estadoLiquidacion) {
  return [
    GESTOR_ESTADO_PRE_LIQUIDACION,
    "LIQUIDACION_OBSERVADA",
    GESTOR_ESTADO_LIQUIDACION_RESUELTA,
  ].includes(estadoLiquidacion);
}

export function canEditCostoGestor() {
  return false;
}

export function requiresObsConfirmacion(estadoLiquidacion, row = {}) {
  return (
    estadoLiquidacion === GESTOR_ESTADO_PRE_LIQUIDACION &&
    !!row.obsProveedor &&
    !row.confirmadaGestor
  );
}

export function showConfirmRow(estadoLiquidacion, row = {}) {
  return (
    (estadoLiquidacion === GESTOR_ESTADO_PRE_LIQUIDACION ||
      estadoLiquidacion === "LIQUIDACION_OBSERVADA") &&
    row.estado === GESTOR_ESTADO_PENDIENTE_REVISION
  );
}

export function showActionsBar(estadoLiquidacion) {
  return (
    estadoLiquidacion === GESTOR_ESTADO_PRE_LIQUIDACION ||
    estadoLiquidacion === GESTOR_ESTADO_LIQUIDACION_RESUELTA
  );
}
